import {ReactComponent} from '../app'
import {Button, Col, Row} from "antd"
import CardImageBackground from "../components/cards/CardImageBackground"
import reservationFamilyImage from "../gfx/images/reservation.jpg"
import reservationBistroImage from "../gfx/images/reservation-bistro.jpg"
import OverlayContent from "../components/layout/OverlayContent"
import ReservationWidget from "../components/layout/ReservationWidget"

export default class ReservationPage extends ReactComponent {

  state = {
    loading: false,
    lobsterFamilyReservation: false,
    lobsterBistroReservation: false,
    lobsterFamilyReservationWidget: false,
    lobsterBistroReservationWidget: false,
  }

  openBistroReservation = () => {
    void this.updateState({lobsterBistroReservation: true, lobsterBistroReservationWidget: true})
  }

  openFamilyReservation = () => {
    void this.updateState({lobsterFamilyReservation: true, lobsterFamilyReservationWidget: true})
  }

  closeBistroReservation = () => {

    void this.updateState({lobsterBistroReservation: false})

    setTimeout(() => {
      void this.updateState({lobsterBistroReservationWidget: false})
    }, 750)//timeout for finish animation in OverlayContent

  }

  closeFamilyReservation = () => {

    void this.updateState({lobsterFamilyReservation: false})

    setTimeout(() => {
      void this.updateState({lobsterFamilyReservationWidget: false})
    }, 750)//timeout for finish animation in OverlayContent

  }


  render() {
    return (
      <>
        <section className="container centered full-height">
          <h1 className="main-title">Rezervace</h1>
          <Row gutter={[24, 32]}>
            <Col sm={24} xs={24}>
              <CardImageBackground image={reservationFamilyImage}>
                <Button type="default" block onClick={this.openFamilyReservation}>LOBSTER Family restaurant</Button>
              </CardImageBackground>
            </Col>
            <Col sm={24} xs={24}>
              <CardImageBackground image={reservationBistroImage}>
                <Button type="default" block onClick={this.openBistroReservation}>LOBSTER Bistro</Button>
              </CardImageBackground>
            </Col>
          </Row>

        </section>

        <OverlayContent
          active={this.state.lobsterFamilyReservation}
          onClose={this.closeFamilyReservation}
        >
          <h1 className="page-title">LOBSTER Family Restaurant Rezervace</h1>

          {this.state.lobsterFamilyReservationWidget &&

            <ReservationWidget id="hors-hydra-3218c66a-2f70-44a4-8e8e-530c5ab8c3ad" eid="hydra-3218c66a-2f70-44a4-8e8e-530c5ab8c3ad"/>

          }

          <div className="menu-spacer"></div>
        </OverlayContent>

        <OverlayContent
          active={this.state.lobsterBistroReservation}
          onClose={this.closeBistroReservation}
        >
          <h1 className="page-title">LOBSTER Bistro Rezervace</h1>

          {this.state.lobsterBistroReservationWidget &&

            <ReservationWidget id="hors-hydra-d2a8a182-8a8f-4898-8404-2546837403c3" eid="hydra-d2a8a182-8a8f-4898-8404-2546837403c3"/>

          }

          <div className="menu-spacer"></div>
        </OverlayContent>
      </>
    )
  }
}